module.exports = __webpack_public_path__ + "static/media/avatargenerico.36a7df16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatargenerico.png
// module id = 879
// module chunks = 0